/* Suresh Peddavoora 10/31/2022 2692790263  Modified Work Queues Header and added Header Text
Suresh Peddavoora 12/05/2022 2692790263    Changed Classname for Table Alignments.
*/

import React from 'react';
import LandingPage from '../../LandingPage';
import WorkQueueListTable from './WorkQueueListTable';
const WorkQueueList = () => {
  return (
    <LandingPage title={'Work Queue'} showTabs={true}>
      <div className={`global-field-dash-board`} role="main">
        <WorkQueueListTable />
      </div>
    </LandingPage>
  );
};

export default WorkQueueList;
